import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

  useEffect(() => {
    window.scrollTo({
  top: 0,
  behavior: prefersReducedMotion ? "auto" : "smooth",
});
  }, [pathname, prefersReducedMotion]);

  return null;
};

export default ScrollToTop;
